var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAedIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 51,
    viewBox: "0 0 37 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8455 29.07L12.8776 31.8113H14.5566L10.9367 22.2488H9.51957L5.80724 31.8113H7.47086L8.50291 29.07H11.8609H11.8455ZM10.1819 24.5437L11.291 27.5878H9.04205L10.1973 24.5437H10.1819ZM17.0366 23.7309V26.1375H21.781V27.6197H17.0366V30.3131H22.1507V31.7953H15.4808V22.2328H22.0891V23.715H17.0366V23.7309ZM30.1145 30.5522C30.8385 29.7553 31.1928 28.5759 31.1928 27.0141C31.1928 25.4522 30.8231 24.2728 30.1145 23.4759C29.3905 22.6791 28.3122 22.2647 26.9259 22.2328H23.5987V31.7953H26.9259C28.3122 31.7634 29.3905 31.3331 30.1145 30.5522ZM25.1545 30.3131V23.7309H26.51C27.0799 23.7309 27.5729 23.7947 27.9734 23.9222C28.3584 24.0338 28.6665 24.225 28.8976 24.4641C29.144 24.7191 29.3135 25.0378 29.4367 25.4522C29.5599 25.8825 29.6216 26.4084 29.6216 27.03C29.6216 27.6516 29.5599 28.1775 29.4367 28.6078C29.3289 29.0062 29.144 29.3409 28.8976 29.5959C28.6511 29.8509 28.343 30.0263 27.958 30.1537C27.5575 30.2812 27.0645 30.345 26.4946 30.345H25.139L25.1545 30.3131ZM25.0158 0H3.09617V1.59375H23.1366V14.3438H35.4288V49.4063H1.54038V0H0V51H36.9692L37 12.3834L25.0158 0ZM24.6615 12.75V1.9125L35.1361 12.75H24.6615Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAedIco);
export default __webpack_public_path__ + "static/media/aed-ico.95db4b72cd29724488f35ba1c1a5c246.svg";
export { ForwardRef as ReactComponent };